import { useQuery } from "@tanstack/react-query";
import $api from "@/zapi-frontend/shared/api/axios";
import { toast } from "sonner";
import { tryCatch } from "@/zapi-frontend/shared/lib/tryCatch";
import { TProjectTemplate } from "./types";
import { useMeStore } from "@/zapi-frontend/shared/hooks/useMe";
import { useFeatureFlag } from "@/zapi-frontend/shared/hooks/useFeatureFlag";
import { useOrganizationStore } from "@/zapi-frontend/stores/organization";

// Claude-code-generation orgs create projects without templates, so template
// endpoints must never be called for them; loading resolves once flags are known.
export function useProjectTemplates(language?: string) {
  const role = useMeStore((s) => s.role);
  const currentOrganizationId = useOrganizationStore((s) => s.currentOrganizationId);
  const claudeGeneration = useFeatureFlag("claude-code-generation");

  const { data, isPending } = useQuery({
    queryKey: ["project-templates", currentOrganizationId, language ?? null],
    queryFn: async () => {
      const [response, error] = await tryCatch(
        $api.get<{ data: TProjectTemplate[] }>("/project-templates", {
          params: language ? { language } : undefined,
        })
      );
      if (error) {
        toast.error(error.message);
        throw error;
      }
      return response.data.data;
    },
    enabled: !!role && claudeGeneration === false,
  });

  return {
    projectTemplates: data ?? [],
    isProjectTemplatesLoading: claudeGeneration === undefined || (claudeGeneration === false && isPending),
  };
}
